import { render } from "./UserBirthInfoSelection.vue?vue&type=template&id=5ba1612a&scoped=true"
import script from "./UserBirthInfoSelection.vue?vue&type=script&lang=js"
export * from "./UserBirthInfoSelection.vue?vue&type=script&lang=js"

import "./UserBirthInfoSelection.vue?vue&type=style&index=0&id=5ba1612a&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ba1612a"]])

export default __exports__